export const isImage = (url: string) => {
  return /\.(jpg|jpeg|png|webp|avif|gif|JPG|svg)$/.test(url);
};
